import React, { useMemo } from 'react';
// import { Surface } from '../../../../ui/components/Surface';

interface PaperProps {
  children: React.ReactNode;
  padding?: 'none' | 'x' | 'y' | 'xy' | string;
  border?: boolean;
  className?: string;
  fit?: boolean;
  overflow?: 'auto' | 'hidden' | 'visible';
}

export default function Paper({
  children,
  padding = 'xy',
  border = true,
  className = '',
  fit = false,
  overflow = 'visible',
}: PaperProps) {
  const heightClass = useMemo(() => {
    return fit ? 'h-fit' : 'h-full';
  }, [fit]);

  // return <Surface className={heightClass}>{children}</Surface>;

  return (
    <div className={`rounded-2  bg-white  ${heightClass} ${className}`} style={{ overflow }}>
      {children}
    </div>
  );
}
